import { render, staticRenderFns } from "./psiclassify.vue?vue&type=template&id=51b52110&"
import script from "./psiclassify.vue?vue&type=script&lang=js&"
export * from "./psiclassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports